'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ComponentLoader = function (_React$Component) {
    _inherits(ComponentLoader, _React$Component);

    function ComponentLoader() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ComponentLoader);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ComponentLoader.__proto__ || Object.getPrototypeOf(ComponentLoader)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            dots: [],
            renderDots: true
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ComponentLoader, [{
        key: 'buildDots',
        value: function buildDots() {
            var rows = Math.round(this.componentLoaderNode.scrollWidth / 34);
            var columns = Math.round(this.componentLoaderNode.scrollHeight / 34);
            var count = rows * columns;
            var dots = [];
            for (var i = 0; i < count; i++) {
                var delay = i * 75 / columns + i;
                dots.push({
                    style: {
                        'animationDelay': delay + 'ms'
                    }
                });
            }
            this.setState({ dots: dots });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (!prevProps.loaded && this.props.loaded) {
                this.setState({ renderDots: false });
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.buildDots();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'component-loader-comp',
                    ref: function ref(node) {
                        _this2.componentLoaderNode = node;
                    } },
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('component-loader-spinner', { 'is-loaded': this.props.loaded }) },
                    _react2.default.createElement(
                        'div',
                        { className: 'background-loader' },
                        this.state.renderDots && (0, _map2.default)(this.state.dots, function (dot, idx) {
                            return _react2.default.createElement('div', { className: 'dot', key: idx, style: dot.style });
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('sub-component-to-load', { 'is-loaded': this.props.loaded }) },
                    this.props.children
                )
            );
        }
    }]);

    return ComponentLoader;
}(_react2.default.Component);

ComponentLoader.propTypes = {
    loaded: _propTypes2.default.bool.isRequired,
    children: _propTypes2.default.any
};
ComponentLoader.defaultProps = {
    loaded: false
};
exports.default = ComponentLoader;
//# sourceMappingURL=index.js.map